/* eslint-disable no-shadow */
import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

export class OPTIntroductionServiceOrderApi implements IAPI {
  prefix = '/OPTIntroductionVideoServiceOrder'

  fetchList (params: TOPTIntroductionVideoService.FetchList) {
    const url = appendParams(`${this.prefix}/GetPagedOrders`, params)
    return API.get<TOPTIntroductionVideoService.TState['optIntroductionVideoServiceOrderList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TOPTIntroductionVideoService.TState['introductionVideoOrderDetail']>(`${this.prefix}/GetById?Id=${id}`)
  }

  saveChangeStatus (data: any) {
    return API.patch(`${this.prefix}/ChangeStatus`, data)
  }

  async downloadExcel (params: any) {
    const url = appendParams('OPTIntroductionVideoServiceOrder/DownloadExcel', params)
    const response = await API.get(url, { responseType: 'blob' })
    return response.data
  }
}

export const optIntroductionServiceOrderApi = new OPTIntroductionServiceOrderApi()
